var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row__image",on:{"click":function($event){_vm.modalIsVisible = true}}},[_c('img',{staticClass:"image__elem",attrs:{"src":_vm.imageSrc}})]),_vm._v(" "),_c('FullsizeImageModal',{attrs:{"show":_vm.modalIsVisible,"image-src":_vm.imageSrc},on:{"close":function($event){_vm.modalIsVisible = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3dd78a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/_shared/features/table/ImageRow.vue
// module id = null
// module chunks = 